(() => {
  const NEWSLETTER_SELECTOR = '.footer-block__newsletter';

  let scheduled = false;

  function extraNodes(nodes) {
    return Array.from(nodes).slice(1);
  }

  function dedupeFooterKlaviyoForms() {
    document.querySelectorAll(NEWSLETTER_SELECTOR).forEach((newsletter) => {
      extraNodes(newsletter.querySelectorAll(':scope > .klaviyo-form-Jhm3Bq')).forEach((node) => node.remove());
      extraNodes(newsletter.querySelectorAll(':scope > form.klaviyo-form')).forEach((form) => form.remove());
    });
  }

  function scheduleDedupe() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      dedupeFooterKlaviyoForms();
      bindGenderDropdowns();
    });
  }

  function observeNewsletters() {
    document.querySelectorAll(NEWSLETTER_SELECTOR).forEach((newsletter) => {
      if (newsletter.dataset.klaviyoDedupeObserved === 'true') return;
      newsletter.dataset.klaviyoDedupeObserved = 'true';
      new MutationObserver(scheduleDedupe).observe(newsletter, { childList: true });
      new MutationObserver(bindGenderDropdowns).observe(newsletter, { childList: true, subtree: true });
    });
  }

  function setNativeValue(input, value) {
    const descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    descriptor.set.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindGenderDropdown(dropdown) {
    if (dropdown.dataset.uaGenderBound === 'true') return;
    dropdown.dataset.uaGenderBound = 'true';

    let remembered = '';
    let opening = false;

    const getCombo = () => dropdown.querySelector('input[role="combobox"]');
    const getToggle = () => dropdown.querySelector('button[id*="toggle"]');

    const applyReadonly = () => {
      const combo = getCombo();
      if (!combo) return;
      combo.readOnly = true;
      combo.setAttribute('inputmode', 'none');
      combo.setAttribute('autocomplete', 'off');
    };

    const restoreIfEmpty = () => {
      if (opening) return;
      const combo = getCombo();
      if (!combo || combo.getAttribute('aria-expanded') === 'true') return;
      if (combo.value) {
        remembered = combo.value;
        return;
      }
      if (remembered) setNativeValue(combo, remembered);
    };

    applyReadonly();

    dropdown.addEventListener('pointerdown', (event) => {
      applyReadonly();
      const combo = getCombo();
      if (!combo) return;
      if (combo.getAttribute('aria-expanded') === 'true') return;
      if (event.target.closest('[role="option"]')) return;

      remembered = combo.value || remembered;
      if (!combo.value) return;

      event.preventDefault();
      event.stopPropagation();
      opening = true;
      setNativeValue(combo, '');
      requestAnimationFrame(() => {
        applyReadonly();
        getToggle()?.click();
        window.setTimeout(() => {
          opening = false;
        }, 50);
      });
    }, true);

    dropdown.addEventListener('keydown', (event) => {
      const combo = getCombo();
      if (!combo) return;
      const opensMenu = event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ';
      if (opensMenu && combo.getAttribute('aria-expanded') !== 'true' && combo.value) {
        remembered = combo.value;
        opening = true;
        setNativeValue(combo, '');
      }
      if (event.key === 'Backspace' || event.key === 'Delete') event.preventDefault();
      if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
        event.preventDefault();
      }
    }, true);

    dropdown.addEventListener('focusout', () => {
      window.setTimeout(restoreIfEmpty, 150);
    });

    new MutationObserver(() => {
      applyReadonly();
      restoreIfEmpty();
    }).observe(dropdown, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  }

  function bindGenderDropdowns() {
    document.querySelectorAll('footer .klaviyo-dropdown').forEach(bindGenderDropdown);
  }

  window.dedupeFooterKlaviyoForms = dedupeFooterKlaviyoForms;

  const start = () => {
    observeNewsletters();
    dedupeFooterKlaviyoForms();
    bindGenderDropdowns();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('product:swapped', scheduleDedupe);
  document.addEventListener('variant:change', scheduleDedupe);
})();
